'use strict';

module.exports = isContentType;

function isContentType( header ){
	return header.toLowerCase() === 'content-type';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/pull-fetch-iso/src/is-content-type.js
 ** module id = 1766
 ** module chunks = 0
 **/